import { render, staticRenderFns } from "./DetailHasilUjianSPRINT.vue?vue&type=template&id=ea2b856e&scoped=true"
import script from "./DetailHasilUjianSPRINT.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianSPRINT.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianSPRINT.vue?vue&type=style&index=0&id=ea2b856e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b856e",
  null
  
)

export default component.exports